import SysColumn from "app/class/sys-column";

export function automaticFormColumns(columns: SysColumn[]): SysColumn[] {
    return columns.filter(column => column.name !== "sys_class_name");
}
